const state = {
  name: '',
  id: 0,
  isLeader: false,
  isHost: false,
  role: '',
}

const getters = {
  userName: state => state.name,
  userId: state => state.id,
  isLeader: state => state.isLeader,
  isHost: state => state.isHost,
  role: state => state.role,
}

const actions = {
  beLeader({ commit }) {
    commit('beLeader')
  },
  beMember({ commit }) {
    commit('beMember')
  },
  setMyName({ commit }) {
    commit('setMyName')
  },
  setMyId({ commit }) {
    commit('setMyId')
  },
  setMyInfo({ commit }) {
    commit('setMyInfo')
  },
  setHost({ commit }) {
    commit('setHost')
  },
  setMyRole({ commit }) {
    commit('setMyRole')
  },
  clearUserInfo({ commit }) {
    commit('clearUserInfo')
  }
}

const mutations = {
  beLeader(state) {
    state.isLeader = true
  },
  beMember(state) {
    state.isLeader = false
  },
  setMyName(state, payload) {
    state.name = payload
  },
  setMyId(state, payload) {
    state.id = payload
  },
  setMyInfo(state, payload) {
    if (payload.name) {
      state.name = payload.name
    }
    if (payload.id) {
       state.id = payload.id
    }
    if (payload.isHost) {
       state.isHost = payload.isHost
    }
  },
  setHost(state) {
    state.isHost = true
  },
  setMyRole(state, payload) {
    state.role = payload
  },
  clearUserInfo(state) {
    state.name = ''
    state.id = 0
    state.isLeader = false
    state.isHost = false
    state.role = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
